module.exports = __webpack_public_path__ + "media/images/juju-logo-c8acd99897fee4ce07736e7311698cf8.jpg";